import { WidgetProduct } from "../../lib/types";

type ProductCardProps = {
  product: WidgetProduct;
};

export function ProductCard({ product }: ProductCardProps) {
  const symbol = product.currency?.symbol ?? product.currency?.code ?? "";
  const basePrice = Number(product.priceAmount ?? 0);
  const discount = Number(product.discountAmount ?? 0);
  const hasDiscount = discount > 0;
  const effectivePrice = Math.max(basePrice - discount, 0);

  return (
    <div className="flex gap-3 rounded-lg border border-gray-200 p-2">
      <div className="h-14 w-14 flex-shrink-0 overflow-hidden rounded-md bg-gray-100">
        {product.featuredImage ? (
          <img
            src={product.featuredImage}
            alt={product.name ?? "Product"}
            className="h-full w-full object-cover"
          />
        ) : null}
      </div>
      <div className="flex flex-1 flex-col justify-center">
        <p className="text-sm font-medium text-gray-900">
          {product.name ?? "Untitled product"}
        </p>
        <p className="text-sm text-gray-500">
          {product.priceAmount ? (
            <>
              {symbol}
              {effectivePrice.toFixed(2)}
              {hasDiscount ? (
                <span className="ml-1 text-xs text-red-500 line-through">
                  {symbol}
                  {basePrice.toFixed(2)}
                </span>
              ) : null}
            </>
          ) : (
            "—"
          )}
        </p>
      </div>
    </div>
  );
}
